import { render, staticRenderFns } from "./reporting-group-1.vue?vue&type=template&id=4f97112b"
import script from "./reporting-group-1.vue?vue&type=script&lang=js"
export * from "./reporting-group-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports